import React from 'react'
import PropTypes from 'prop-types'

import { FlexGrid, Box, Typography } from '@telus-uds/components-web'

import { components } from '@digital-commerce/shared-utils'

import { InlineBox, WrapInlineBox } from './styles'

import { displayShippingValue, formatCurrency, hasAttribute } from './utils'
import MonthlyChargesTooltip from './MonthlyChargesTooltip'

const getCostValue = (cost, lang) => {
  if (typeof cost === 'string') return cost
  return formatCurrency(cost, lang)
}

const LineItem = ({
  amountBold,
  annotation,
  annotationInline,
  bold,
  cost,
  dataIdAttribute,
  lang,
  termsAndCondition,
  text,
  showTooltip
}) => {
  const { ShouldRender } = components
  const isShippingItem = hasAttribute('price-summary-shipping', dataIdAttribute)
  return (
    <FlexGrid>
      <FlexGrid.Row distribute="between" testID={dataIdAttribute}>
        <WrapInlineBox>
          <Box vertical={1}>
            <InlineBox inline={annotationInline}>
              <Typography variant={{ size: 'medium', bold }}>
                {text}
                <MonthlyChargesTooltip
                  lang={lang}
                  showTooltip={showTooltip}
                  dataTestId={dataIdAttribute}
                />
                <ShouldRender when={Boolean(termsAndCondition)}>{termsAndCondition}</ShouldRender>
              </Typography>
              {annotation && <Typography variant={{ size: 'medium' }}>{annotation}</Typography>}
            </InlineBox>
          </Box>
        </WrapInlineBox>
        <ShouldRender when={!isShippingItem}>
          <Box vertical={1}>
            <Typography variant={{ size: 'medium', bold: amountBold }}>
              {getCostValue(cost, lang)}
            </Typography>
          </Box>
        </ShouldRender>
        <ShouldRender when={isShippingItem}>
          <Box vertical={1}>
            <Typography variant={{ size: 'medium', bold: amountBold }} display="block">
              {displayShippingValue({
                cost,
                lang,
                getCostValue
              })}
            </Typography>
          </Box>
        </ShouldRender>
      </FlexGrid.Row>
    </FlexGrid>
  )
}

LineItem.propTypes = {
  text: PropTypes.string.isRequired,
  cost: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  lang: PropTypes.oneOf(['en', 'fr']).isRequired,
  amountBold: PropTypes.bool,
  annotation: PropTypes.string,
  annotationInline: PropTypes.bool,
  bold: PropTypes.bool,
  dataIdAttribute: PropTypes.string,
  termsAndCondition: PropTypes.node,
  showTooltip: PropTypes.bool
}

LineItem.defaultProps = {
  amountBold: false,
  annotation: undefined,
  annotationInline: false,
  bold: false,
  dataIdAttribute: '',
  termsAndCondition: false,
  showTooltip: false
}

export default LineItem
